export default __webpack_public_path__ + "static/media/pets.90d542c3.svg";